import { useState, useCallback } from 'react'

// Ausgeblendete Geständnisse – nur lokal auf diesem Gerät, kein Account nötig.
const STORAGE_KEY = 'reverend_hidden'
const MAX_ENTRIES = 500

function load() {
  try {
    const ids = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')
    return Array.isArray(ids) ? ids : []
  } catch {
    return []
  }
}

function save(ids) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids))
  } catch { /* Speicher voll oder blockiert – dann eben nur für diese Sitzung */ }
}

export function useHiddenPosts() {
  const [hiddenIds, setHiddenIds] = useState(load)

  const toggleHidden = useCallback((id) => {
    setHiddenIds(prev => {
      const next = prev.includes(id)
        ? prev.filter(x => x !== id)
        : [id, ...prev].slice(0, MAX_ENTRIES)
      save(next)
      return next
    })
  }, [])

  return { hiddenIds, toggleHidden }
}
